import {Typography} from "@mui/material";

export default function GameTitle({marginTop = 10}:{marginTop?:number}) {
    return <Typography variant={"h1"} fontFamily={"'Caesar Dressing', cursive"} color={"#003D92"} fontWeight={"bold"}
                       sx={{mt: marginTop, textAlign: "center"}}>Santorini</Typography>
}
